import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeStyle as _normalizeStyle, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ref } from 'vue';
import AtomTippyJS from './AtomTippyJS.vue';
import { Placement } from 'tippy.js';

interface IProps {
    label: string,
    tooltipPosition: Placement,
    tooltipLabel: string,
}


export default /*#__PURE__*/_defineComponent({
  __name: 'AtomCheckBoxButton',
  props: {
    label: {},
    tooltipPosition: {},
    tooltipLabel: {}
  },
  emits: ['check'],
  setup(__props: any, { emit: __emit }) {

const props = __props
const emit = __emit

const labelStyle = ref('color: var(--components-main100);font-weight: 600;')
const checkboxStyle = ref('color: #FF5C00; background-color: #FF5C001A;')
const checkboxValue = ref(true)

function changeClass(value: boolean) {
    if (value) {
        labelStyle.value = 'color: var(--components-main100);font-weight: 600;'
        checkboxStyle.value = 'color: #FF5C00; background-color: #FF5C001A;'
        emit('check', true)
    } else {
        labelStyle.value = 'color: var(--components-subtitle);font-weight:400;'
        checkboxStyle.value = 'color: #D6DBE1; background-color: #F6F7F9;'
        emit('check', false)
    }
}

return (_ctx: any,_cache: any) => {
  const _component_v_label = _resolveComponent("v-label")!
  const _component_v_checkbox = _resolveComponent("v-checkbox")!

  return (_openBlock(), _createBlock(AtomTippyJS, {
    placement: props.tooltipPosition,
    theme: "default",
    text: props.tooltipLabel
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_checkbox, {
        style: _normalizeStyle(checkboxStyle.value),
        class: "custom_checkBox",
        modelValue: checkboxValue.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((checkboxValue).value = $event)),
        onChange: _cache[1] || (_cache[1] = ($event: any) => (changeClass(checkboxValue.value)))
      }, {
        label: _withCtx(() => [
          _createVNode(_component_v_label, {
            style: _normalizeStyle(labelStyle.value),
            class: "custom_label"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(props.label), 1)
            ]),
            _: 1
          }, 8, ["style"])
        ]),
        _: 1
      }, 8, ["style", "modelValue"])
    ]),
    _: 1
  }, 8, ["placement", "text"]))
}
}

})